module.exports = __webpack_public_path__ + "static/media/fly0209.a95c4241.webp";